import React, { Component } from "react";
import SearchGen from "./SearchGen";
import Resumen from "./Resumen";

export default class Inicio extends Component {
	constructor(props) {
		super();
		this.state = {
			mainColor: "#F33A3A"
		};
	}
	render() {
		return (
			<div>
				<div className="tramaBusquedaGen">
					<div className="container" id="busquedaGen">
						<SearchGen history={this.props.history} />
					</div>
				</div>
				<div className="container">
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Inicio.js